import { DASHBOARD_COLORS, buildCssVariablesBlock } from './colors';

const buildVanDashboardStyles = () => `
  @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=DM+Mono:wght@400;500&display=swap');

  .van-dashboard, .van-dashboard * , .van-dashboard *::before, .van-dashboard *::after {
    box-sizing: border-box;
  }

  .van-dashboard {
${buildCssVariablesBlock()}
    --sidebar-w: 220px;
    --header-h:  60px;
    --radius:    10px;
    --radius-lg: 14px;
    --section-gap: 50px;
    --stack-gap: 12px;
    font-family: 'DM Sans', sans-serif;
    font-size: 14px;
    line-height: 1.5;
    color: var(--text);
  }

  .van-dashboard .layout { display: block; }

  .van-dashboard .main { display: block; min-width: 0; }

  .van-dashboard .content {
    overflow-x: hidden;
    padding: 0 0 8px;
    scroll-behavior: smooth;
    display: flex;
    flex-direction: column;
    gap: var(--section-gap);
  }

  .van-dashboard .dash-section {
    margin: 0;
    padding: 0;
    position: static;
  }

  .van-dashboard .section-head {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 15px;
    padding-bottom: 4px;
    border-bottom: 1px solid var(--border);
  }

  .section-head-icon {
    width: 26px;
    height: 26px;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
  }

  .section-head-title {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: .08em;
    text-transform: uppercase;
    color: var(--text2);
  }

  .section-head-count {
    margin-left: auto;
    font-size: 11px;
    color: var(--text3);
    font-family: 'DM Mono', monospace;
  }

  .section-body {
    display: flex;
    flex-direction: column;
    gap: var(--stack-gap);
  }

  .g10  { display: grid; grid-template-columns: repeat(auto-fit, minmax(140px,1fr)); gap: 8px; }
  .g5   { display: grid; grid-template-columns: repeat(auto-fit, minmax(130px,1fr)); gap: 8px; }
  .g4   { display: grid; grid-template-columns: repeat(auto-fit, minmax(160px,1fr)); gap: 8px; }
  .g3   { display: grid; grid-template-columns: repeat(3, 1fr); gap: 8px; }
  .g2   { display: grid; grid-template-columns: 1fr 1fr; gap: 8px; }
  .g21  { display: grid; grid-template-columns: 2fr 1fr; gap: 8px; }
  .g12  { display: grid; grid-template-columns: 1fr 2fr; gap: 8px; }

  .kpi {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 10px 12px;
    cursor: default;
    transition: transform .15s, box-shadow .15s, border-color .15s;
  }

  .kpi:hover {
    transform: translateY(-2px);
    border-color: var(--border2);
    box-shadow: 0 8px 24px ${DASHBOARD_COLORS.shadow};
  }

  .kpi-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
  }

  .kpi-label {
    font-size: 10px;
    font-weight: 600;
    letter-spacing: .07em;
    text-transform: uppercase;
    color: var(--text2);
    line-height: 1.3;
  }

  .kpi-icon-wrap {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
  }

  .kpi-val {
    font-size: 22px;
    font-weight: 700;
    line-height: 1;
    font-family: 'DM Mono', monospace;
  }

  .kpi-sub { font-size: 11px; color: var(--text2); margin-top: 5px; }

  .kpi-blue  .kpi-icon-wrap { background: var(--blue-l);  } .kpi-blue  .kpi-val { color: var(--blue);  }
  .kpi-green .kpi-icon-wrap { background: var(--green-l); } .kpi-green .kpi-val { color: var(--green); }
  .kpi-amber .kpi-icon-wrap { background: var(--amber-l); } .kpi-amber .kpi-val { color: var(--amber); }
  .kpi-red   .kpi-icon-wrap { background: var(--red-l);   } .kpi-red   .kpi-val { color: var(--red);   }
  .kpi-violet .kpi-icon-wrap { background: var(--violet-l);} .kpi-violet .kpi-val { color: var(--violet);}
  .kpi-teal  .kpi-icon-wrap { background: var(--teal-l);  } .kpi-teal  .kpi-val { color: var(--teal);  }

  .card {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius-lg);
    overflow: hidden;
    box-shadow: 0 1px 4px ${DASHBOARD_COLORS.shadowSoft};
  }

  .card-head {
    padding: 8px 14px;
    border-bottom: 1px solid var(--border);
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: var(--bg3);
  }

  .card-head-title {
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: .07em;
    color: var(--text2);
  }

  .card-head-action { font-size: 11px; color: var(--blue); cursor: pointer; }
  .card-body { padding: 10px 14px; }

  .bar-row { margin-bottom: 8px; }
  .bar-row:last-child { margin-bottom: 0; }
  .bar-meta { display: flex; justify-content: space-between; margin-bottom: 5px; font-size: 12px; }
  .bar-lbl { color: var(--text2); }
  .bar-track { height: 6px; background: ${DASHBOARD_COLORS.trackBg}; border-radius: 99px; overflow: hidden; }
  .bar-fill  { height: 100%; border-radius: 99px; transition: width 1.3s cubic-bezier(.4,0,.2,1); }

  .tbl-wrap { overflow-x: auto; }

  .tbl-wrap-scroll {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 320px;
  }

  .tbl-wrap-scroll thead th {
    position: sticky;
    top: 0;
    z-index: 1;
    background: var(--bg3);
  }

  .tbl-wrap-scroll::-webkit-scrollbar { width: 5px; height: 5px; }
  .tbl-wrap-scroll::-webkit-scrollbar-track { background: transparent; }
  .tbl-wrap-scroll::-webkit-scrollbar-thumb { background: ${DASHBOARD_COLORS.scrollbarThumb}; border-radius: 99px; }

  table { width: 100%; border-collapse: collapse; min-width: 400px; }
  thead tr { background: var(--bg3); }
  th {
    padding: 7px 12px;
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: .07em;
    color: var(--text3);
    text-align: left;
    border-bottom: 1px solid var(--border);
    white-space: nowrap;
  }
  th.td-align-left, td.td-align-left { text-align: left; }
  th.td-align-center, td.td-align-center { text-align: center; }
  th.td-align-right, td.td-align-right { text-align: right; }
  td { padding: 8px 12px; font-size: 13px; color: var(--text); border-bottom: 1px solid var(--border); }
  tbody tr:last-child td { border-bottom: none; }
  tbody tr:hover { background: ${DASHBOARD_COLORS.rowHover}; }
  .td-mono { font-family: 'DM Mono', monospace; }

  .badge {
    display: inline-flex;
    align-items: center;
    font-size: 11px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 99px;
    white-space: nowrap;
  }

  .b-green  { background: var(--green-l);  color: var(--green); }
  .b-blue   { background: var(--blue-l);   color: var(--blue);  }
  .b-amber  { background: var(--amber-l);  color: var(--amber); }
  .b-red    { background: var(--red-l);    color: var(--red);   }
  .b-violet { background: var(--violet-l); color: var(--violet);}
  .b-gray   { background: ${DASHBOARD_COLORS.grayLight}; color: var(--text2); }

  .btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 7px 14px;
    border-radius: 8px;
    border: 1px solid var(--border2);
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    background: var(--bg3);
    color: var(--text2);
    font-family: 'DM Sans', sans-serif;
    transition: background .15s, color .15s, border-color .15s;
  }

  .btn:hover { background: var(--surface2); color: var(--text); border-color: var(--border2); }
  .btn-icon { font-size: 14px; }

  .funnel { display: flex; align-items: center; gap: 6px; padding: 10px 14px; }
  .funnel-step { flex: 1; border-radius: var(--radius); padding: 10px 8px; text-align: center; border: 1px solid; }
  .funnel-arrow { color: var(--text3); font-size: 18px; flex-shrink: 0; }
  .funnel-val { font-size: 22px; font-weight: 700; font-family: 'DM Mono', monospace; }
  .funnel-lbl { font-size: 11px; color: var(--text2); margin-top: 3px; }

  .legend { display: flex; flex-wrap: wrap; gap: 8px; margin-bottom: 8px; }
  .legend-item { display: flex; align-items: center; gap: 6px; font-size: 12px; color: var(--text2); }
  .legend-dot { width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; }

  .inv-row {
    display: flex;
    align-items: center;
    padding: 8px 14px;
    border-bottom: 1px solid var(--border);
    gap: 12px;
  }

  .inv-row:last-child { border-bottom: none; }
  .inv-name { font-size: 13px; font-weight: 500; color: var(--text); }
  .inv-sub  { font-size: 11px; color: var(--text2); margin-top: 2px; }
  .inv-bar  { flex: 1; max-width: 120px; }
  .inv-stock { font-size: 13px; font-weight: 600; font-family: 'DM Mono', monospace; min-width: 52px; text-align: right; }

  .chart-box { position: relative; }

  .donut-wrap { display: flex; align-items: center; gap: 14px; padding: 0; }
  .donut-canvas-wrap { position: relative; flex-shrink: 0; }
  .donut-center {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    text-align: center;
    pointer-events: none;
  }

  .donut-center-val { font-size: 17px; font-weight: 700; font-family: 'DM Mono', monospace; }
  .donut-center-lbl { font-size: 10px; color: var(--text2); }

  .content::-webkit-scrollbar { width: 5px; }
  .content::-webkit-scrollbar-track { background: transparent; }
  .content::-webkit-scrollbar-thumb { background: ${DASHBOARD_COLORS.scrollbarThumb}; border-radius: 99px; }

  @media (max-width: 1100px) {
    .g10 { grid-template-columns: repeat(auto-fit, minmax(130px,1fr)); }
  }

  @media (max-width: 900px) {
    .g3 { grid-template-columns: 1fr 1fr; }
    .g21 { grid-template-columns: 1fr; }
    .g12 { grid-template-columns: 1fr; }
  }

  @media (max-width: 640px) {
    .van-dashboard .content { padding: 0 0 8px; gap: 6px; }
    .g2, .g3 { grid-template-columns: 1fr; }
    .g10, .g5 { grid-template-columns: repeat(2, 1fr); }
    .funnel { flex-wrap: wrap; }
    .funnel-step { min-width: 70px; }
    .funnel-arrow { display: none; }
  }

  @keyframes dashShimmer {
    0%   { background-position: -200% 0; }
    100% { background-position: 200% 0; }
  }

  @keyframes fadeUp {
    from { opacity: 0; transform: translateY(10px); }
    to   { opacity: 1; transform: translateY(0); }
  }

  .van-dashboard .dash-skeleton-line,
  .van-dashboard .dash-skeleton-icon,
  .van-dashboard .dash-skeleton-donut,
  .van-dashboard .dash-skeleton-bar-fill,
  .van-dashboard .dash-skeleton-chart,
  .van-dashboard .dash-skeleton-funnel-step {
    background: linear-gradient(90deg, var(--surface2) 0%, ${DASHBOARD_COLORS.shimmerMid} 50%, var(--surface2) 100%);
    background-size: 200% 100%;
    animation: dashShimmer 1.4s ease-in-out infinite;
    border-radius: 6px;
  }

  .van-dashboard .dash-skeleton-kpi {
    background: var(--surface);
    border: 1px solid var(--border);
    border-radius: var(--radius);
    padding: 10px 12px;
    pointer-events: none;
  }

  .van-dashboard .dash-skeleton-kpi-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;
  }

  .van-dashboard .dash-skeleton-icon {
    width: 28px;
    height: 28px;
    border-radius: 7px;
    flex-shrink: 0;
  }

  .van-dashboard .dash-skeleton-kpi .dash-skeleton-line:last-child {
    margin-top: 8px;
  }

  .van-dashboard .dash-skeleton-donut {
    width: 110px;
    height: 110px;
    border-radius: 50%;
    flex-shrink: 0;
  }

  .van-dashboard .dash-skeleton-legend {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
  }

  .van-dashboard .dash-skeleton-bar-fill {
    width: 45%;
    height: 100%;
    border-radius: 99px;
  }

  .van-dashboard .dash-skeleton-chart {
    width: 100%;
    border-radius: var(--radius);
  }

  .van-dashboard .dash-skeleton-funnel-step {
    flex: 1;
    border-radius: var(--radius);
    padding: 10px 8px;
    text-align: center;
    border: 1px solid var(--border);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;
  }

  .van-dashboard .dash-skeleton-table-wrap tbody tr:hover {
    background: transparent;
  }

  .van-dashboard .dash-skeleton-table-wrap td,
  .van-dashboard .dash-skeleton-table-wrap th {
    border-bottom-color: var(--border);
  }

  .van-dashboard .dash-block-loader {
    animation: fadeUp .25s ease both;
  }

  .van-dashboard .dash-section { animation: fadeUp .35s ease both; }
  .van-dashboard .dash-section:nth-child(1) { animation-delay: .04s; }
  .van-dashboard .dash-section:nth-child(2) { animation-delay: .08s; }
  .van-dashboard .dash-section:nth-child(3) { animation-delay: .12s; }
  .van-dashboard .dash-section:nth-child(4) { animation-delay: .16s; }
  .van-dashboard .dash-section:nth-child(5) { animation-delay: .20s; }
  .van-dashboard .dash-section:nth-child(6) { animation-delay: .24s; }
`;

export const STYLE_ELEMENT_ID = 'van-dash-styles';

export default buildVanDashboardStyles;
